import { apiGetCall } from 'src/services/api/api.core';
import { EApiEndpoint } from 'src/config/enums';

export const getCountry = async (): Promise<{ country: string } | null> =>
    apiGetCall(EApiEndpoint.GeoipCountry);
